import { Card, Col, Flex, Row } from 'antd'
import dayjs from 'dayjs'

import { EpidemiologyCaseForm058E_PrimaryDiagnosticSection } from 'src/api/requests'
import { Text } from 'src/components'
import { dayMonthYearHourMinutesFormatWithDot } from 'src/libs'
import { useLocales } from 'src/locales'

type Props = {
  primaryDiagnostic: EpidemiologyCaseForm058E_PrimaryDiagnosticSection
}
export const EpidemiologyPrimaryDiagnosticDetailsCard = ({
  primaryDiagnostic
}: Props) => {
  const { t, currentLang } = useLocales()

  return (
    <Card title={t('epidemiology.primary_diagnostic')}>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Flex vertical gap={4}>
            <Text>{t('epidemiology.diagnoses_title')}</Text>
            <Flex vertical gap={8}>
              {primaryDiagnostic.diagnoses?.map((item, index) => (
                <Text
                  key={index}
                  weight={400}
                >{`${index + 1}. ${item.code} - ${item.name?.[currentLang.value]}`}</Text>
              ))}
            </Flex>
          </Flex>
        </Col>

        <Col span={12}>
          <Flex vertical gap={4}>
            <Text>{t('epidemiology.diagnostic_date_time')}</Text>

            <Text weight={400}>
              {dayjs(primaryDiagnostic.diagnosisDate).format(
                dayMonthYearHourMinutesFormatWithDot
              )}
            </Text>
          </Flex>
        </Col>

        <Col span={12}>
          <Flex vertical gap={4}>
            <Text>{t('epidemiology.date_time_of_disease_onset')}</Text>

            <Text weight={400}>
              {dayjs(primaryDiagnostic.dateOfDiseaseOnset).format(
                dayMonthYearHourMinutesFormatWithDot
              )}
            </Text>
          </Flex>
        </Col>

        <Col span={24}>
          <Flex vertical gap={4}>
            <Text>{t('epidemiology.classification_level')}</Text>

            <Text weight={400}>
              {
                primaryDiagnostic.classificationLevel?.name?.[
                  currentLang?.value
                ]
              }
            </Text>
          </Flex>
        </Col>
      </Row>
    </Card>
  )
}
